import { useEffect, useState } from 'react';
import { PricingService } from './pricing.service';
import { TPricingPlans } from './types';

export const useDataForPlansPricing = (planList: string[]): TPricingPlans[] => {
  const [cardData, setCardData] = useState<TPricingPlans[]>([]);
  useEffect(() => {
    PricingService.getPlanPricingAndDetails(planList).then((data) =>
      setCardData(data)
    );
  }, []);

  return cardData;
};
